/**
 * Pure helpers of the dial pad: what the number field accepts and how a French
 * number reads on screen. Normalization to E.164 stays server-side
 * (`normalizeToE164` in the telephony Edge Functions) — the pad only cleans input.
 */

/** Characters a caller can dial: digits, the DTMF keys, and a leading "+". */
export function sanitizeDialInput(raw: string): string {
  const kept = raw.replace(/[^\d+*#]/g, '');
  // "+" only makes sense as the international prefix.
  const plusFirst = kept.startsWith('+');
  return (plusFirst ? '+' : '') + kept.replace(/\+/g, '');
}

/** Whether the field holds something worth dialing (at least a short number). */
export function isDialable(value: string): boolean {
  return value.replace(/\D/g, '').length >= 3;
}

/**
 * "+33612345678" → "06 12 34 56 78"; other numbers are returned as is. Display
 * only: the E.164 value is what gets dialed and compared.
 */
export function formatPhoneForDisplay(e164: string): string {
  const fr = /^\+33(\d{9})$/.exec(e164);
  if (!fr) return e164;
  return `0${fr[1]}`.replace(/(\d{2})(?=\d)/g, '$1 ');
}
